<template>
    <div style="display: flex; flex-direction: column;">
        <MercenaryHeader :title="'스카우팅 리포트'" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <InfinityScroll :refresh-action="refresh" :handleNextPage="handleNextPage" :isEnableNextPageHandle="isEnableNextPageHandle">
            <div style="position: relative;">
                <div style="position: absolute; z-index: 1;">
                    <img style="width: 100%; object-fit: cover;" :src="require('@/assets/img/scouting_report_main.png')" alt="">
                </div>
                <div style="position: relative; z-index: 2; padding: 0 12px;">
                    <div style="display: flex; align-items: center; gap: 12px; padding-top: 24px;">
                        <div style="border-radius: 12px; width: 50px; height: 50px; overflow: hidden; border: 1px solid #d9d9d9;">
                            <img style="width: 100%; height: 100%;" :src="$resourcePath + coachInfo.image_path" alt="">
                        </div>
                        <div style="color: #fff;">
                            <div style="font-weight: 500;">{{ coachInfo.nic_name }}님,</div>
                            <div style="font-size: 12px; margin-top: 8px;">팀 분석을 시작해 볼까요?</div>
                        </div>
                    </div>
                    <div style="display: flex; gap: 10px; margin-top: 11px; margin-bottom: 24px;">
                        <div style="display: flex; gap: 5px; align-items:center; background: linear-gradient(90deg, #2376FF 0%, #00AFD6 100%); padding: 5px 7px; border-radius: 8px;">
                            <img style="width: 10px;" :src="require('@/assets/img/coach_report.png')" alt="">
                            <div style="color: #fff; font-weight: 500; font-size: 12px;">{{ coachInfo.coach_type === '감독' ? '감독' : '코치' }}</div>
                        </div>
                        <div v-if="coachInfo.licenses" style="display: flex; gap: 5px; align-items:center ; background: linear-gradient(90deg, #2376FF 0%, #00AFD6 100%); padding: 5px 7px; border-radius: 8px;">
                            <img style="width: 10px;" :src="require('@/assets/img/license_report.png')" alt="">
                            <div style="color: #fff; font-weight: 500; font-size: 12px;">{{ coachInfo.licenses }}</div>
                        </div>
                        <div style="display: flex; gap: 5px; align-items:center ; background: linear-gradient(90deg, #2376FF 0%, #00AFD6 100%); padding: 5px 7px; border-radius: 8px;">
                            <img style="width: 10px;" :src="require('@/assets/img/active_region.png')" alt="">
                            <div style="color: #fff; font-weight: 500; font-size: 12px;">{{ coachInfo.team.name }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="flex: 1; padding: 0 12px; font-weight: 500; padding-top: 20px;">
                <div style="border-radius: 12px; background-color: #E9FDFF; padding: 8px; border: 1px solid #D6E7FE">
                    <div style="display: flex; align-items: center; gap: 5px;">
                        <div>
                            <img style="width: 25px;" :src="require('@/assets/img/report_AI.png')" alt="">
                        </div>
                        <div style="font-weight: 700;">AI 분석 결과</div>
                    </div>
                    <ul style="margin: 0; padding-left: 32px; white-space: nowrap;">
                        <li style="font-size: 12px; line-height: 16px; margin-top: 2px;">이번주 팀이 <span style="font-size: 14px; color: var(--color-main);">{{ weekTeamCnt }}회</span> 조회되었어요.<br>
                            <template v-if="interestStatus === INTEREST_STAUTS.SAME">지난주와 동일한 관심이에요</template>
                            <template v-else-if="interestStatus === INTEREST_STAUTS.INCREASE">지난주보다 {{ interestPercent }}% 더 많은 관심이에요.</template>
                            <template v-else-if="interestStatus === INTEREST_STAUTS.DECREASE">지난주보다 {{ interestPercent }}% 관심이 감소했어요.</template>
                        </li>
                        <li style="font-size: 12px; line-height: 16px; margin-top: 10px;">새로운 입단 요청서 <span style="font-size: 14px; color: var(--color-main);">{{ notReadRequestCnt }}건이</span> 도착했습니다.</li>
                        <li style="font-size: 12px; line-height: 16px; margin-top: 10px;">이번 주 감독님이 <span style="font-size: 14px; color: var(--color-main);">{{ visitProfileCnt }}명의 선수</span>를 조회했고,<br>그중 <span style="font-size: 14px; color: var(--color-main);"> {{ teamVisitCnt }}명</span>은 이후 팀을 다시 방문했습니다.</li>
                    </ul>
                </div>
                <div style="display: flex; margin-top: 15px; gap: 18px;">
                    <div @click="setCurTab(CUR_TAB.TEAM_VIEW_CNT)" :style="{ opacity: curTab === CUR_TAB.TEAM_VIEW_CNT ? '1' : '0.2' }" style="background: #FFEFDC; border: 1px solid #FFD19E; border-radius: 12px; padding: 12px; flex: 1; display: flex; align-items: center; flex-direction: column;">
                        <div style="margin-bottom: 8px; border-radius: 50%; width: 20px; height: 20px; text-align: center; background-color: var(--color-main);">
                            <img style="width: 10px;" :src="require('@/assets/img/reporting_search.png')" alt="">
                        </div>
                        <div style="text-align: center;">
                            <div style="font-size: 20px; font-weight: 700;">{{ teamViewCnt }}</div>
                            <div style="font-size: 12px; margin-top: 8px; font-weight: 500;">팀 조회수</div>
                        </div>
                    </div>
                    <div @click="setCurTab(CUR_TAB.JOIN_REQUEST)" :style="{ opacity: curTab === CUR_TAB.JOIN_REQUEST ? '1' : '0.2' }" style="background: #CFF6D2; border: 1px solid #ACF0B1; border-radius: 12px; padding: 12px; flex: 1; display: flex; align-items: center; flex-direction: column;">
                        <div style="margin-bottom: 8px; border-radius: 50%; width: 20px; height: 20px; text-align: center; background: #2B8D32;">
                            <img style="width: 8px;" :src="require('@/assets/img/reporting_request.png')" alt="">
                        </div>
                        <div style="text-align: center;">
                            <div style="font-size: 20px; font-weight: 700;">{{ joinRequestCnt }}</div>
                            <div style="font-size: 12px; margin-top: 8px; font-weight: 500;">입단 요청서</div>
                        </div>
                    </div>
                    <div @click="setCurTab(CUR_TAB.TRY_SCOUT)" :style="{ opacity: curTab === CUR_TAB.TRY_SCOUT ? '1' : '0.2' }" style="background: #DEECFF; border: 1px solid #B7D7FF; border-radius: 12px; padding: 12px; flex: 1; display: flex; align-items: center; flex-direction: column;">
                        <div style="margin-bottom: 8px; border-radius: 50%; width: 20px; height: 20px; text-align: center; background: #2366DB;">
                            <img style="width: 12px;" :src="require('@/assets/img/reporting_scout.png')" alt="">
                        </div>
                        <div style="text-align: center;">
                            <div style="font-size: 20px; font-weight: 700;">{{ tryScoutCnt }}</div>
                            <div style="font-size: 12px; margin-top: 8px; font-weight: 500;">스카우트 시도</div>
                        </div>
                    </div>
                </div>
                <template v-if="curTab === CUR_TAB.TEAM_VIEW_CNT">
                    <div style="margin-top: 24px;">
                        <div style="margin-bottom: 24px; font-weight: 700;">우리 팀을 살펴본 선수들</div>
                    </div>
                    <div>
                        <div v-for="each, i in viewedPlayers " :key="i + 'viewd_players'" style="display: flex; align-items: center; margin-bottom: 20px;">
                            <div style="display: flex; align-items: center; gap: 20px; flex: 1;">
                                <div style="font-weight: 700;">{{ each.rank }}</div>
                                <CommonProfileNew :memberInfo="each"></CommonProfileNew>
                            </div>
                            <div style="font-weight: 700; color: var(--color-main);">{{ each.visit_count }}회</div>
                        </div>
                        <div @click="showMoreViewedPlayers" style="border: 2px solid #210F031A; width: 155px; height: 40px; border-radius: 10px; margin: 0 auto; margin-top: 30px; gap: 6px; justify-content: center; text-align: center; display: flex; align-items: center;">
                            <div style="font-size: 14px">더보기</div>
                        </div>
                    </div>
                    <div style="margin-top: 24px;">
                        <div style="margin-bottom: 24px; font-weight: 700;">우리 팀에 관심 가진 선수</div>
                    </div>
                    <div style=" padding-bottom: 20px;">
                        <div v-for="each, i in interestedPlayers " :key="i + 'interested_players'" style="display: flex; align-items: center; margin-bottom: 24px;">
                            <div style="flex: 1;">
                                <CommonProfileNew :memberInfo="each"></CommonProfileNew>
                            </div>
                            <div @click="sendMessage(each)" style="width: 78px; height: 40px; border-radius: 12px; line-height: 40px; text-align: center; background-color: #f5f5f5; color: var(--color-main); font-size: 14px; font-weight: 700;">메시지</div>
                        </div>
                        <div @click="showInterestedPlayers" style="border: 2px solid #210F031A; width: 155px; height: 40px; border-radius: 10px; margin: 0 auto; margin-top: 30px; gap: 6px; justify-content: center; text-align: center; display: flex; align-items: center;">
                            <div style="font-size: 14px">더보기</div>
                        </div>
                    </div>
                </template>
                <template v-else-if="curTab === CUR_TAB.JOIN_REQUEST">
                    <div style="margin-top: 30px;">
                        <div v-for="each, i in joinRequests" :key="i + 'join_requests'" style="margin-bottom: 12px;">
                            <div @click="$Util.showProfile(each.from_member.idx, MEMBER_TYPE.USER, 0);" style="display: flex; gap: 8px; align-items: center; margin-bottom: 12px;">
                                <div>
                                    <ProfileImage :imagePath="each.from_member.image_path" style="width: 40px;"></ProfileImage>
                                </div>
                                <div style="width:100%;">
                                    <div style="font-weight: 700; font-size: 12px; margin-bottom: 4px;width:100%;position:relative;">
                                        {{ each.from_member.nic_name }}
                                        <span style="color: var(--color-main);">
                                            <DivisionPositionText :position="each.from_member.position"></DivisionPositionText>
                                        </span>
                                    </div>
                                    <div style="display: flex; align-items: center; gap: 4px; font-weight: 500; font-size: 12px; line-height: 16px; color:#210F03; opacity: 0.7;">
                                        {{ each.from_member.place.name }}
                                        <span style="display: inline-block; width: 2px; height: 2px; border-radius: 50%; background: #210F03B2;"></span>
                                        {{ each.insert_date | agoDateStr }}
                                    </div>
                                </div>
                                <div style="flex:1;"></div>
                            </div>
                            <div style="background: linear-gradient(90deg, rgba(255, 113, 17, 0.1) 0%, rgba(33, 15, 3, 0.1) 100%); padding: 12px; border-radius: 12px; padding-bottom: 0; padding-top: 8px;">
                                <CommonPost :hideProfile="true" :isChat="true" :soccerHows="each.soccerhow"></CommonPost>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else-if="curTab === CUR_TAB.TRY_SCOUT">
                    <div style="margin-top: 30px;">
                        <div v-for="each, i in tryScoutList" :key="i + 'try_scout'" style="display: flex; align-items: center; margin-bottom: 24px;">
                            <div style="flex: 1;">
                                <CommonProfileNew :memberInfo="each"></CommonProfileNew>
                            </div>
                            <div @click="sendMessage(each)" style="width: 78px; height: 40px; border-radius: 12px; line-height: 40px; text-align: center; background-color: #f5f5f5; color: var(--color-main); font-size: 14px; font-weight: 700;">메시지</div>
                        </div>
                    </div>
                </template>
            </div>
        </InfinityScroll>
    </div>
</template>

<script>
import MercenaryHeader from '@/components/common/MercenaryHeader'
import InfinityScroll from '@/components/common/InfinityScroll'
import CommonProfileNew from '@/components/common/CommonProfileNew';
import CommonPost from '@/components/soccerhowmain/CommonPost';
import DivisionPositionText from '@/components/common/DivisionPositionText'
import ProfileImage from '@/components/common/ProfileImage'
import { DIRECT_MESSAGE_TYPE, MEMBER_TYPE } from '@/Constants'

const CUR_TAB = {
    TEAM_VIEW_CNT: 'TEAM_VIEW_CNT',
    JOIN_REQUEST: 'JOIN_REQUEST',
    TRY_SCOUT: 'TRY_SCOUT'
}

const INTEREST_STAUTS = {
    INCREASE: 'increase',
    DECREASE: 'decrease',
    SAME: 'same'
}

const SCOUTING_TYPE = {
    // 우리 팀을 살펴본 선수들
    VIEWED: 'viewed',
    // 우리팀에 관심가진 선수들
    INTERESTED: 'interested'
}

export default {
    name: 'ScoutingReport',
    components: { MercenaryHeader, CommonProfileNew, InfinityScroll, CommonPost, DivisionPositionText, ProfileImage },
    props: {
        teamIdx: {
            type: [String, Number],
            default: -1
        }
    },
    created() {
        this.getMyTeamAnalyze()
        this.getMyTeamViews(true, true)
    },
    data() {
        return {
            MEMBER_TYPE: MEMBER_TYPE,
            INTEREST_STAUTS: INTEREST_STAUTS,
            CUR_TAB: CUR_TAB,
            curTab: CUR_TAB.TEAM_VIEW_CNT,
            joinRequests: [],
            viewedPlayers: [],
            interestedPlayers: [],
            tryScoutList: [],
            isEnableNextPageHandle: true,
            page: 1,
            teamViewCnt: 0,
            joinRequestCnt: 0,
            tryScoutCnt: 0,
            notReadRequestCnt: 0,
            visitProfileCnt: 0,
            interestPercent: 0,
            isMoreInterest: true,
            isSameInterest: false,
            weekTeamCnt: 0,
            teamVisitCnt: 0,
            interestStatus: INTEREST_STAUTS.INCREASE,
            coachInfo: {}
        }
    },
    methods: {
        sendMessage(memberInfo) {
            this.$Util.showDirectMessageSenderForm({ memberInfo: memberInfo, isDirectUser: true });
        },
        refresh() {
            if (this.curTab === CUR_TAB.TEAM_VIEW_CNT) {
                this.viewedPlayers = []
                this.interestedPlayers = []
                this.getMyTeamViews()
            } else if (this.curTab === CUR_TAB.JOIN_REQUEST) {
                this.joinRequests = []
                this.page = 1
                this.getMyJoinRequests()
            } else if (this.curTab === CUR_TAB.TRY_SCOUT) {
                this.tryScoutList = []
                this.getMyTryScouts()
            }
            this.getMyTeamAnalyze()
        },
        handleNextPage() {
            if (this.curTab === CUR_TAB.JOIN_REQUEST) {
                this.page++
                this.getMyJoinRequests()
            }
        },
        setCurTab(tab) {
            if (this.curTab === tab) {
                return
            }
            this.curTab = tab
            if (this.curTab === CUR_TAB.TEAM_VIEW_CNT) {
                this.viewedPlayers = []
                this.interestedPlayers = []
                this.getMyTeamViews()
            } else if (this.curTab === CUR_TAB.JOIN_REQUEST) {
                this.page = 1
                this.joinRequests = []
                this.getMyJoinRequests()
            } else if (this.curTab === CUR_TAB.TRY_SCOUT) {
                this.tryScoutList = []
                this.getMyTryScouts()
            }
        },
        async getMyTeamAnalyze() {
            const parameters = {}
            parameters.team_idx = this.teamIdx

            const res = await this.$Axios.get('/api/coach/scouting/team_analyze', { params: parameters })
            const teamViewCnt = res.data.team_view_cnt
            const joinRequestCnt = res.data.join_request_cnt
            const tryScoutCnt = res.data.try_scout_cnt
            const notReadRequestCnt = res.data.not_read_request_cnt
            const visitProfileCnt = res.data.visit_profile_cnt
            const interestStatus = res.data.interest_status
            const interestPercent = res.data.interest_percent
            const weekTeamCnt = res.data.week_team_cnt
            const teamVisitCnt = res.data.team_visit_cnt
            const coachInfo = res.data.coach_info

            this.coachInfo = coachInfo
            this.teamViewCnt = teamViewCnt
            this.joinRequestCnt = joinRequestCnt
            this.tryScoutCnt = tryScoutCnt
            this.notReadRequestCnt = notReadRequestCnt
            this.visitProfileCnt = visitProfileCnt
            this.interestPercent = interestPercent
            this.weekTeamCnt = weekTeamCnt
            this.interestStatus = interestStatus
            this.teamVisitCnt = teamVisitCnt
        },
        showMoreViewedPlayers() {
            this.$GlobalStore.addModal('ScoutingReportDetail', { mode: SCOUTING_TYPE.VIEWED, teamIdx: this.teamIdx })
        },
        showInterestedPlayers() {
            this.$GlobalStore.addModal('ScoutingReportDetail', { mode: SCOUTING_TYPE.INTERESTED, teamIdx: this.teamIdx })
        },
        async getMyTeamViews() {
            const parameters = {}
            parameters.team_idx = this.teamIdx
            parameters.team_views_page = 1
            parameters.interested_page = 1
            parameters.is_get_team_views = true
            parameters.is_get_interested_players = true

            const res = await this.$Axios.get('/api/coach/scouting/team_views', { params: parameters })
            const viewedPlayers = res.data.viewed_players
            const interestedPlayers = res.data.interested_players

            this.viewedPlayers = viewedPlayers.splice(0, 5)
            this.setRanking()
            this.interestedPlayers = interestedPlayers.splice(0, 6)
        },
        setRanking() {
            const sorted = [...this.viewedPlayers].sort((a, b) => b.visit_count - a.visit_count);
            let prevCount = null;
            let prevRank = 0;
            let realRank = 0;

            sorted.forEach((item) => {
                realRank++;
            
                if (item.visit_count !== prevCount) {
                    prevRank = realRank;
                    prevCount = item.visit_count;
                }
            
                item.rank = prevRank;
            });
        },
        async getMyJoinRequests() {
            this.isEnableNextPageHandle = false
            const parameters = {}
            parameters.page = this.page
            parameters.status = -1
            parameters.direct_message_types = [ DIRECT_MESSAGE_TYPE.REQUEST_TO_COACH ]

            const res = await this.$Axios.get('/api/direct_message/mine', { params: parameters })
            const joinRequests = res.data.direct_message
            if (joinRequests.length > 0) {
                this.isEnableNextPageHandle = true
                this.joinRequests = [...this.joinRequests, ...joinRequests]
            }
        },
        async getMyTryScouts() {
            const res = await this.$Axios.get('/api/coach/scouting/try_scout')

            const tryScoutList = res.data.try_scouts
            this.tryScoutList = tryScoutList
        }
    }
}
</script>

<style scoped>

</style>